<template>
  <b-modal
      id="modal-buscar-itens-pic"
      ref="modal"
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      hide-footer
  >
    <template #modal-title>
      Selecione um Item
    </template>
    <b-card>
      <b-col class="mt-1 mb-1">
        <b-row class="col-12">
          <b-col md="2">
            <b-form-group label="Marca">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <b-spinner small variant="success" v-show="getIsLoadingMarca"/>
                  <feather-icon icon="TagIcon" size="18"
                                :color="$store.state.intensPedido.setExisteMarca ? '#1f9d57' : '#dc2626'"
                                v-if="getIsLoadingMarca === false"/>
                </b-input-group-prepend>
                <b-form-select
                    v-model="selected_cod_marca"
                    :options="getEsMarcas"
                    :state="$store.state.intensPedido.setExisteMarca"
                    @change="getCategoriaPedido"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Categoria">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <b-spinner small variant="success" v-show="getIsLoadingCategoria"/>
                  <feather-icon icon="ShoppingBagIcon" size="18"
                                :color="$store.state.intensPedido.setExisteCategoria ? '#1f9d57' : '#dc2626'"
                                v-if="getIsLoadingCategoria === false"/>
                </b-input-group-prepend>

                <b-form-select
                    v-model="selected_categoria"
                    aria-placeholder="Selecione a categoria"
                    :options="getEsCategorias"
                    :disabled="!selected_cod_marca || getIsLoadingCategoria"
                    :state="$store.state.intensPedido.setExisteCategoria"
                    @change="getReferenciaPedido"
                />
                <b-form-invalid-feedback
                    v-show="getIsLoadingCategoria === false && !$store.state.intensPedido.setExisteCategoria"
                    tooltip
                >
                  A marca selecionada não possui categorias cadastradas.
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Referência">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <b-spinner small variant="success" v-show="$store.getters['intensPedido/getIsLoadingReferencia']"/>
                  <feather-icon icon="ClipboardIcon" size="18"
                                :color="$store.state.intensPedido.setExisteReferencia ? '#1f9d57' : '#dc2626'"
                                v-if="$store.getters['intensPedido/getIsLoadingReferencia'] === false"/>
                </b-input-group-prepend>
                <b-form-select
                    v-model="selected_referencia"
                    :options="$store.getters['intensPedido/getEsReferencias']"
                    :disabled="!selected_categoria"
                    :state="$store.state.intensPedido.setExisteReferencia"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Código">
              <b-form-input type="text" v-model="searchCodigo"/>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Descrição">
              <b-form-input type="text" v-model="searchDescricao"/>
            </b-form-group>
          </b-col>
          <b-col class="mt-2" cols="2" md="1">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                class="w-100"
                @click="clearFilters"
            >
              <feather-icon icon="TrashIcon" size="18"/>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-table :items="paginatedItems" :fields="fields">
        <template #head(select)>
          <b-form-checkbox
              v-model="selectAll"
              @change="toggleSelectAll"
              aria-label="Selecionar todos"
          ></b-form-checkbox>
        </template>

        <!-- Checkbox em cada linha -->
        <template #cell(select)="data">
          <b-form-checkbox
              :value="data.item"
              v-model="selectedItems"
              aria-label="Selecionar item"
          ></b-form-checkbox>
        </template>
        <!--      <template #cell(actions)="data">-->
        <!--        <b-button @click="selectItem(data.item)" variant="primary">Selecionar</b-button>-->
        <!--      </template>-->
      </b-table>

      <b-pagination
          v-model="currentPage"
          :total-rows="filteredItems.length"
          :per-page="perPage"
          class="d-flex justify-content-center mt-3"
      >

      </b-pagination>
      <div class="d-flex justify-content-end
">
        <b-button
            variant="primary"
            @click="showQuantityModal"
        >
          Continuar
        </b-button>
      </div>

    </b-card>

        <ModalAdd
            idModal="modal-quantidade-desconto"
            ref="quantityDiscountModal"
            titleModal="Definir Quantidade e Desconto"
            :labelBtnOk="'Adicionar'"
             :picid="picid"
             :tabelaprecoid="tabelaprecoid"
            @ok="hide()"
        />
  </b-modal>

</template>
<script>
import {
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BFormSelect,
  BModal,
  BRow,
  BPagination,
  BTable,
} from 'bootstrap-vue';
import axios from '@/libs/axios';
import { mapActions, mapGetters } from 'vuex';
import ModalAdd from '@/views/app/operacoes/picitem/list/ModalAdd.vue';

export default {
  components: {
    ModalAdd,
    BFormGroup,
    BCol,
    BCard,
    BButton,
    BModal,
    BRow,
    BPagination,
    BTable,
    BFormSelect,
  },
  props: {
    items: Array,
    marcas: Array,
    categorias: Array,
    referencias: Array,
    codigos: Array,
    descricoes: Array,
    picid: Number,
    tabelaprecoid: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      quantity: 1,
      discount: 0,
      selectedItems: [], // Armazena os itens selecionados
      selectAll: false,
      marcas: [],
      searchCodigo: '',
      searchDescricao: '',
      selected_cod_marca: '',
      selected_categoria: '',
      selected_referencia: '',
      currentPage: 1,
      perPage: 10,
      fields: [
        { key: 'select', label: '' },
        { key: 'value', label: 'Codigo' },
        { key: 'text', label: 'Descrição' },
        // { key: 'cod_marca', label: 'Marca' },
        // { key: 'cod_categoria', label: 'Categoria' },
        // { key: 'referencia', label: 'Referencia' },
        // { key: 'actions', label: 'Ações' }
      ],
    };
  },
  mounted() {
    this.getMarcaPedido();
    this.selectedItems = [];
  },
  computed: {
    filteredItems() {
      return this.items.filter((item) => {
        const marcaMatches = !this.selected_cod_marca || (item.cod_marca && item.cod_marca === this.selected_cod_marca);
        const categoriaMatches = !this.selected_categoria || (item.cod_categoria && item.cod_categoria === this.selected_categoria);
        const referenciaMatches = !this.selected_referencia || (item.referencia && item.referencia.includes(this.selected_referencia.codReferencia));
        const codigoMatches = !this.searchCodigo || (item.value && item.value.toLowerCase().includes(this.searchCodigo.toLowerCase()));
        const descricaoMatches = !this.searchDescricao || (item.text && item.text.toLowerCase().includes(this.searchDescricao.toLowerCase()));

        return marcaMatches && categoriaMatches && referenciaMatches && codigoMatches && descricaoMatches;
      });
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredItems.slice(start, end);
    },
    ...mapGetters('intensPedido', [
      'getEsMarcas',
      'getIsLoadingMarca',
      'getEsCategorias',
      'getIsLoadingCategoria',
      'getEsReferencias',
      'getIsLoadingReferencia',
      'getEsEmbalagens',
      'getIsLoadingEmbalagem',
      'getFormData',
      'getlistarTabelaItens',
    ]),
  },
  methods: {
    ...mapActions('intensPedido', [
      'itensMarcaPedido',
      'itensCategoriaPedido',
      'itensReferenciaPedido',
      'itensEmbalagemPedido',
      'itensdetalhes',
      'setListTabelaItens',
      'clearModalItens',
      'buscaCorGradeItens',
    ]),
    toggleSelectAll() {
      // Seleciona ou desmarca todos os itens visíveis
      this.selectedItems = this.selectAll ? [...this.filteredItems] : [];
    },
    async getMarcaPedido() {
      this.marcas = [];
      this.marcas = await this.itensMarcaPedido('BR24A');
      this.selected_categoria = null;
      this.selected_referencia = null;
      this.selected_embalagem = null;
    },
    async getCategoriaPedido() {
      if (this.selected_cod_marca) {
        this.categorias = await this.itensCategoriaPedido(this.selected_cod_marca);
        this.selected_categoria = null;
        this.selected_referencia = null;
        this.selected_embalagem = null;
      }
    },
    async getReferenciaPedido() {
      if (this.selected_cod_marca && this.selected_categoria) {
        await this.itensReferenciaPedido({
          selected_cod_marca: this.selected_cod_marca,
          selected_categoria: this.selected_categoria,
        });
        this.selected_referencia = null;
      }
    },
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$emit('ok');
      this.selectedItems = [];
      this.clearFilters();
      this.$refs.modal.hide();
    },
    selectItem(item) {
      this.$emit('select-item', item);
      this.$refs.modal.hide();
    },
    emitSearch() {
      this.currentPage = 1; // Reset page to 1 após busca
    },
    clearFilters() {
      this.searchCodigo = '';
      this.searchDescricao = '';
      this.selected_cod_marca = '';
      this.selected_categoria = '';
      this.selected_referencia = '';
      this.currentPage = 1; // Reset page to 1 após limpar filtros
    },
    showQuantityModal() {
      this.$refs.quantityDiscountModal.showModal(this.selectedItems);
    },
    closeQuantityModal() {
      this.$refs.quantityDiscountModal.hide();
    },
    // applyQuantityDiscount() {
    //   // Lógica para aplicar quantidade e desconto nos itens selecionados
    //   this.selectedItems = this.selectedItems.map(item => ({
    //     ...item,
    //     quantity: this.quantity,
    //     discount: this.discount
    //   }));
    //   // Fechar modal de quantidade/desconto após aplicar
    //   this.closeQuantityModal();
    //   // Emitir evento ou processar conforme necessário
    //   this.$emit('applied-quantity-discount', this.selectedItems);
    // },
  },
};
</script>
